export enum EntityName {
    AccountTransfer = 'account_transfers',
    Asset = 'assets',
    AssetTranslation = 'asset-translations',
    BatchImport = 'batch_imports',
    BatchMedium = 'batch-mediums',
    Campaign = 'campaigns',
    ExchangeLead = 'exchange_leads',
    FieldPermissions = 'field-permissions',
    IdentityProvider = 'identity-providers',
    Integration = 'integrations',
    IntegrationService = 'integration-services',
    Kompany = 'kompanies',
    LeadCapture = 'lead_captures',
    LeadForm = 'lead-forms',
    Medium = 'mediums',
    MediumDisableReason = 'medium-disable-reasons',
    MemberInvite = 'member_invites',
    MemberSuggestion = 'member-suggestions',
    Order = 'orders',
    OrderPrintConfig = 'order_print_configs',
    OrderShipment = 'order_shipments',
    OrderStatusWorkflowLog = 'order_status_workflow_logs',
    Organization = 'organizations',
    Product = 'products',
    Profile = 'profiles',
    SignatureModel = 'signature-models',
    SocialConnectLink = 'social-connect-links',
    Stats = 'stats',
    Subscription = 'subscriptions',
    Tag = 'tags',
    Team = 'teams',
    User = 'users',
}
